import { notification } from "antd";

const Notification = ({ children }) => {
    const [messageApi, contextHolder] = notification.useNotification();

    return (
        <>
            {contextHolder}
            {children(messageApi)}
        </>
    );
};

export default Notification;